/**
 * A way past the navigation for anyone moving by keyboard.
 *
 * Without it, reaching the content on every page means tabbing through the
 * whole sidebar again. Hidden until focused, which is the one case where
 * hiding something from sight but not from the tab order is correct.
 */
export function SkipLink() {
  return (
    <a
      href="#main"
      className="skip-link"
      onClick={(event) => {
        // The router lives in the fragment, so following "#main" would
        // navigate to a page called "main". Move focus instead.
        event.preventDefault()
        document.getElementById('main')?.focus()
      }}
    >
      Skip to content
    </a>
  )
}
